import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { QuizRenderer } from '@inso_web/quiz-previewer';
import type { QuizQuestion, QuizSettings } from '@inso_web/quiz-previewer/types';
import { quizApi } from '../api/client';

// Preview-страница: quiz.insoweb.ru/preview/{token}. Грузится через iframe из
// lk-frontend (страница builder/preview). Token — JWT, выданный quiz-API
// через /preview-token (TTL 5мин). Quiz-API валидирует JWT и отдаёт draft.

interface PreviewResponse {
  ok: boolean;
  quiz: {
    id: string;
    slug: string;
    titleRu: string;
    titleEn: string;
    questions: QuizQuestion[];
    settings: QuizSettings;
  };
}

export function PreviewPage() {
  const { token } = useParams<{ token: string }>();

  const { data, isLoading, error } = useQuery({
    queryKey: ['preview-quiz', token],
    queryFn: () => quizApi.get<PreviewResponse>(`/preview/${token}`).then((r) => r.data.quiz),
    enabled: !!token,
    retry: false,
  });

  if (isLoading) return <CenteredText>Loading preview…</CenteredText>;
  if (error || !data) return <CenteredText>Preview link expired or invalid</CenteredText>;

  // Preview-режим: submit отключён, onComplete нет.
  return (
    <QuizRenderer
      questions={data.questions ?? []}
      settings={data.settings ?? ({} as QuizSettings)}
      quizId={data.id}
      lang="ru"
    />
  );
}

function CenteredText({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui, sans-serif', color: '#666' }}>
      <p>{children}</p>
    </div>
  );
}
